export default __webpack_public_path__ + "static/media/illustration.88ac9d25.svg";